// ============================================================
// AVIS VOYAGEURS — liste modifiable facilement
// ------------------------------------------------------------
// 🛠️ POUR AJOUTER UN AVIS : dupliquez un objet ci-dessous.
// 🛠️ POUR RETIRER UN AVIS : supprimez ou commentez son objet.
// 🛠️ POUR MODIFIER UN AVIS : changez les champs text / name / place.
// L'ordre du tableau = l'ordre d'affichage sur la page.
// ============================================================

export const REVIEWS = [
  {
    text: "Le cocon d'Eva est une vraie bulle de bonheur et de déconnexion. Le décor est sublime et Eva a tout fait pour rendre notre séjour magique. De la communication fluide, à la déco soignée, en passant par toutes les délicates attentions, tout était absolument parfait. Sans aucun doute le logement le plus joli et paisible dans lequel nous ayons séjourné jusqu'ici.",
    name: "Pauline",
    place: "Fribourg, Suisse · Juillet 2025",
  },
  {
    text: "Petit séjour entre filles très sympathique. Un endroit très apaisant ! On en a pris plein les yeux, merci encore pour l'accueil. Je recommande fortement.",
    name: "Morghane",
    place: "Saint-Denis, Réunion · Janvier 2026",
  },
  {
    text: "Logement toujours parfait, toujours des nouveautés, très propre, très charmant, très chaleureux… je recommande vivement.",
    name: "Cédric",
    place: "France · Décembre 2025",
  },
  {
    text: "Nous avons passé un excellent moment au Curieux Refuge. Éva est très réactive au message et disponible à tout moment. Tout était parfait comme à la description.",
    name: "Aurore",
    place: "France · Septembre 2025",
  },
  {
    text: "Si vous êtes à la recherche d'un endroit calme et reposant, le Curieux Refuge est fait pour vous. L'hôte est très accueillante et laisse des petites attentions. Tout est communiqué en détail via SMS avant l'arrivée. Très beau site, grande salle de bain, tout correspond à la description. Entrée/départ autonome. Encore merci pour cette nuit.",
    name: "Voyageur",
    place: "Avril 2025",
  },
  {
    text: "Séjour très agréable, communication très fluide et réactive avec les hôtes. Je recommande !",
    name: "Camille",
    place: "Airbnb · Février 2026",
  },
  {
    text: "Nous avons passé un excellent séjour au Curieux Refuge. Le logement est calme, romantique, très propre et décoré avec soin. De quoi profiter d'un moment hors du temps !",
    name: "Léa",
    place: "Saint-Denis, Réunion · Janvier 2026",
  },
  {
    text: "Un véritable petit bijou ! Le logement est impeccable, décoré avec goût et très agréable à vivre. Je m'y suis sentie comme à la maison. L'hôte est aux petits soins, attentionnée et réactive. Une adresse que je recommande, vous pouvez vous y rendre les yeux fermés ! J'y reviendrai avec grand plaisir. Coup de cœur absolu !",
    name: "Pauline",
    place: "Fribourg, Suisse · Septembre 2025",
  },
  {
    text: "Le Curieux Refuge est une très belle adresse pour un séjour au calme dans l'ouest. La décoration a été choisie avec goût et les installations ont été bien pensées. Mon coup de cœur va pour le coin hamac dans le jardin pour chiller au soleil. Allez-y les yeux fermés, vous ne regretterez pas !",
    name: "Olinirina",
    place: "Airbnb · Juillet 2025",
  },
  {
    text: "On a adoré le Curieux Refuge, fidèle à la description photo et écrite. Très facile de le trouver, bel emplacement, propre, très beau, dans un environnement paisible. L'hôte est très agréable, on a bien discuté. On s'est laissé tenter par le petit déjeuner… et que de bonnes choses à manger, on s'est régalé. On reviendra, c'est sûr.",
    name: "Elodie",
    place: "Saint-Pierre, Réunion · Juillet 2025",
  },
];

// Statistiques affichées sur la page /avis (modifiables librement)
export const REVIEW_STATS = [
  { value: "★★★★★", label: "Notes voyageurs" },
  { value: "10+", label: "Témoignages" },
  { value: "100%", label: "Recommandent" },
  { value: "2025—2026", label: "Récents" },
];

export default REVIEWS;
